import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getCookie } from "./components/getcookie";
import axios from "axios";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const location = useLocation();
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [globalValue, setGlobalValue] = useState("Hello, World!");
  const [visitorCurrentTab, setVisitorCurrentTab] = useState("queue");
  const [vehicleCurrentTab, setVehicleCurrentTab] = useState("queue");
  const [courierCurrentTab, setCourierCurrentTab] = useState("approved");
  const [nfcCurrentTab, setNfcCurrentTab] = useState("Allocated");

  // Visitor Filters
  const [visitorLocation, setVisitorLocation] = useState("");
  const [visitorDepartment, setVisitorDepartment] = useState([]);
  const [visitorDateRange, setVisitorDateRange] = useState([null, null]);
  const [visitorGateInRange, setVisitorGateInRange] = useState([null, null]);
  const [visitorGateOutRange, setVisitorGateOutRange] = useState([null, null]);

  // Vehicle Filters
  const [vehicleLocation, setVehicleLocation] = useState("");
  const [vehicleDepartment, setVehicleDepartment] = useState([]);
  const [vehicleDateRange, setVehicleDateRange] = useState([null, null]);
  const [vehicleGateInRange, setVehicleGateInRange] = useState([null, null]);
  const [vehicleGateOutRange, setVehicleGateOutRange] = useState([null, null]);

  // Courier Filters
  const [courierLocation, setCourierLocation] = useState("");
  const [courierDepartment, setCourierDepartment] = useState("");
  const [courierDateRange, setCourierDateRange] = useState([null, null]);
  const [courierGateInRange, setCourierGateInRange] = useState([null, null]);
  const [courierGateOutRange, setCourierGateOutRange] = useState([null, null]);

  const rolePermissionValue = localStorage.getItem("rolePermissionList");
  const userTypeValue = localStorage.getItem("userType") ?? [];
  const [rolePermissionList, setRolePermissionList] = useState(JSON.parse(rolePermissionValue) ?? []);
  const [userType, setUserType] = useState(userTypeValue ?? "");
  const [orgImage, setOrgImage] = useState("");
  useEffect(() => {
    console.log('rolePermissionValue', rolePermissionValue)
    localStorage.setItem("rolePermissionValue", rolePermissionList);
    localStorage.setItem("userTypeValue", userType);
  }, [rolePermissionList]);

  const prevModuleRef = useRef(null);

  useEffect(() => {
    const getModule = (path) => {
      if (path.startsWith("/visitors") || path.startsWith("/visitor")) return "visitor";
      if (path.startsWith("/vehicle")) return "vehicle";
      if (path.startsWith("/courier")) return "courier";
      return "other";
    };

    const currentModule = getModule(location.pathname);
    if (prevModuleRef.current && prevModuleRef.current !== currentModule) {
      // Reset Visitor Filters
      setVisitorLocation("");
      setVisitorDepartment([]);
      setVisitorDateRange([null, null]);
      setVisitorGateInRange([null, null]);
      setVisitorGateOutRange([null, null]);

      // Reset Vehicle Filters
      setVehicleLocation("");
      setVehicleDepartment([]);
      setVehicleDateRange([null, null]);
      setVehicleGateInRange([null, null]);
      setVehicleGateOutRange([null, null]);

      // Reset Courier Filters
      setCourierLocation("");
      setCourierDepartment("");
      setCourierDateRange([null, null]);
      setCourierGateInRange([null, null]);
      setCourierGateOutRange([null, null]);
    }
    prevModuleRef.current = currentModule;
  }, [location.pathname]);
  return (
    <GlobalContext.Provider
      value={{
        rolePermissionList, setRolePermissionList,
        userType, setUserType,
        visitorCurrentTab, setVisitorCurrentTab,
        vehicleCurrentTab, setVehicleCurrentTab,
        courierCurrentTab, setCourierCurrentTab,
        nfcCurrentTab, setNfcCurrentTab,
        orgImage, setOrgImage,
        visitorLocation, setVisitorLocation,
        visitorDepartment, setVisitorDepartment,
        visitorDateRange, setVisitorDateRange,
        visitorGateInRange, setVisitorGateInRange,
        visitorGateOutRange, setVisitorGateOutRange,
        vehicleLocation, setVehicleLocation,
        vehicleDepartment, setVehicleDepartment,
        vehicleDateRange, setVehicleDateRange,
        vehicleGateInRange, setVehicleGateInRange,
        vehicleGateOutRange, setVehicleGateOutRange,
        courierLocation, setCourierLocation,
        courierDepartment, setCourierDepartment,
        courierDateRange, setCourierDateRange,
        courierGateInRange, setCourierGateInRange,
        courierGateOutRange, setCourierGateOutRange
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);